let backendHost = `https://back.misoroban.com`;
let websocketHost = `https://back.misoroban.com`;
let port;
let ioport;


if (process.env.NODE_ENV === 'development') {
  /*PROD*/
  // port = 80;
  backendHost = `https://back.misoroban.com`;
  websocketHost = `https://back.misoroban.com`;

  /*LOCAL*/
  // port = 1337;
  // backendHost = `http://192.168.1.38`;
  // ioport = 1337;
  // websocketHost = `http://192.168.1.38`;
} else {
  // port = 80
  backendHost = process.env.REACT_APP_BACKEND_HOST || `https://back.misoroban.com`;
  websocketHost = process.env.REACT_APP_SOCKET_URL || `https://back.misoroban.com`;
}

// console.log('backendHost:',process.env.NODE_ENV,':',backendHost);

module.exports = {
  port,
  uri: `${backendHost}:${port}`,
  API_ROOT: port ? (`${backendHost}:${port}/api`) : (`${backendHost}/api`),
  SOCKET_URL: ioport ? (`${websocketHost}:${port}`) : (`${websocketHost}`),
  IMG_ROOT: `${backendHost}:${port}`,
  version: '0.1.81'
}